import PageTitle from "../ui/PageTitle";
import { useLoaderData, useLocation, useNavigate } from "react-router-dom";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import rrulePlugin from "@fullcalendar/rrule";
import FullCalendar from "@fullcalendar/react";

export default function EventPage() {
  const previous = useLocation().pathname.split("/")[2] === "previous";
  const events = useLoaderData();
  console.log("events:", events)
  const navigate = useNavigate();

  function handleEventClick(clickInfo) {
    navigate(`/event/update/${clickInfo.event.id}`);
  }

  return (
    <>
      <div className="page-div">
        <div className="title-area w-full">
          {previous ? (
            <PageTitle
              title="Previous Events"
              breadcrumb={[
                { name: "home", path: "/" },
                { name: "Previous Events", path: "/event/previous" },
              ]}
            />
          ) : (
            <PageTitle
              title="Upcoming Events"
              breadcrumb={[
                { name: "home", path: "/" },
                { name: "Upcoming Events", path: "/event" },
              ]}
            />
          )}
        </div>

        <div className="aboutus-wrapper w-full">
          <div className="container-x mx-auto py-10">
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, listPlugin, rrulePlugin]}
              initialView="timeGridWeek"
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
              }}
              events={events}
              eventClick={handleEventClick}
            />
          </div>
        </div>
      </div>
    </>
  );
}
